import React, { useEffect, useState } from "react";
import api from "../../services/api";

import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../Grupos/cadastroGrupo.scss";
import Swal from "sweetalert2";
import { useQueryClient } from "@tanstack/react-query";

export default function Grupos_cad() {
  /* =========================================================
     ESTADOS
     ========================================================= */

  const [marcadores, setMarcadores] = useState([]);
  const [notificacoesPredefinidas, setNotificacoesPredefinidas] = useState([]);
  const [notificacoesSelecionadas, setNotificacoesSelecionadas] = useState([]);

  const [searchVeiculos, setSearchVeiculos] = useState("");
  const [searchVeiculosSelecionados, setSearchVeiculosSelecionados] = useState("");
  const queryClient = useQueryClient();




  const [values, setValues] = useState({});

  const [loadingVeiculos, setLoadingVeiculos] = useState(true);
  const [mostrarLoading, setMostrarLoading] = useState(true);

  const navigate = useNavigate();

  /* =========================================================
     CONFIGURAÇÕES
     ========================================================= */

  const MAX_NOME = 50;


  /* =========================================================
     BUSCAR VEÍCULOS / EQUIPAMENTOS
     ========================================================= */

  useEffect(() => {
    async function fetchData() {
      try {
        setLoadingVeiculos(true);

        const cliente = localStorage.getItem("id");

        const { data } = await api.get("/equipamentos", {
          headers: {
            typo: cliente
          }
        });

        const lista = data.map(
          (item) => `${item.placa}  |  ${item.nome}`
        );

        setNotificacoesPredefinidas(lista);
      } catch (error) {
        console.error(
          "Erro ao buscar equipamentos:",
          error.response?.data || error
        );
      } finally {
        setLoadingVeiculos(false);
      }
    }

    fetchData();
  }, []);

  /* =========================================================
     DELAY DO LOADING
     ========================================================= */

  useEffect(() => {
    const timer = setTimeout(() => {
      setMostrarLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);


  /* =========================================================
     HANDLE CHANGE
     ========================================================= */

  const handleChange = (event) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };


  /* =========================================================
     SELECIONAR VEÍCULO
     ========================================================= */

  const handleSelecionadas = (valor) => {
    setNotificacoesSelecionadas((prev) => [
      ...prev,
      valor,
    ]);

    setNotificacoesPredefinidas((prev) =>
      prev.filter((placa) => placa !== valor)
    );
  };


  /* =========================================================
     DEVOLVER VEÍCULO PARA LISTA
     ========================================================= */

  const handlePredefinidas = (valor) => {
    setNotificacoesPredefinidas((prev) => [
      ...prev,
      valor,
    ]);

    setNotificacoesSelecionadas((prev) =>
      prev.filter((placa) => placa !== valor)
    );
  };


  /* =========================================================
     SELECIONAR / DESMARCAR TODOS
     ========================================================= */

  const handleAll = (value) => {
    if (value) {
      setNotificacoesSelecionadas((prev) => [
        ...prev,
        ...notificacoesPredefinidas,
      ]);

      setNotificacoesPredefinidas([]);
    } else {
      setNotificacoesPredefinidas((prev) => [
        ...prev,
        ...notificacoesSelecionadas,
      ]);

      setNotificacoesSelecionadas([]);
    }
  };


  /* =========================================================
     FILTRO DE VEÍCULOS
     ========================================================= */

  const filterPlaca = notificacoesPredefinidas.filter(
    (placa) =>
      placa
        .toLowerCase()
        .includes(searchVeiculos.toLowerCase())
  );

  /* =========================================================
     FILTRO DE VEÍCULOS SELECIONADOS
     ========================================================= */

  const filterVeiculosSelecionados = notificacoesSelecionadas.filter(
    (veiculo) =>
      veiculo
        .toLowerCase()
        .includes(searchVeiculosSelecionados.toLowerCase())
  );


  /* =========================================================
     CADASTRAR GRUPO
     ========================================================= */

  const handleSubmit = async (e) => {
    e?.preventDefault();

    /* -------------------------------------------------------
       VALIDAÇÕES
       ------------------------------------------------------- */

    if (!values.nome?.trim()) {
      await Swal.fire({
        icon: "warning",
        title: "Nome obrigatório",
        text: "Informe um nome para o grupo.",

        background: "#0f172a",
        color: "#ffffff",

        confirmButtonColor: "#0ea5e9",

        scrollbarPadding: false,
        heightAuto: false,
      });

      return;
    }

    if (notificacoesSelecionadas.length === 0) {
      await Swal.fire({
        icon: "warning",
        title: "Nenhum veículo selecionado",
        text: "Selecione pelo menos um veículo para cadastrar o grupo.",

        background: "#0f172a",
        color: "#ffffff",

        confirmButtonColor: "#0ea5e9",

        scrollbarPadding: false,
        heightAuto: false,
      });

      return;
    }


    /* -------------------------------------------------------
       CONFIRMAÇÃO
       ------------------------------------------------------- */

    const confirm = await Swal.fire({

      title: "Cadastrar grupo",

      icon: "question",
      iconColor: "#8fd3ff",

      background: "#0b1722",
      color: "#e8f1f7",

      width: "500px",
      padding: "1.4rem",

      html: `
    <div class="swal-grupo-cadastro">

      <div class="swal-grupo-cadastro-description">
        Confira os dados antes de continuar.
      </div>


      <div class="swal-grupo-cadastro-data">

        <div class="swal-grupo-cadastro-item">

          <span class="swal-grupo-cadastro-label">
            Grupo
          </span>

          <span class="swal-grupo-cadastro-value">
            ${values.nome || "Sem nome"}
          </span>

        </div>


        <div class="swal-grupo-cadastro-item">

          <span class="swal-grupo-cadastro-label">
            Veículos
          </span>

          <span class="swal-grupo-cadastro-value">
            ${notificacoesSelecionadas.length}
            ${notificacoesSelecionadas.length === 1
          ? " veículo selecionado"
          : " veículos selecionados"
        }
          </span>

        </div>

      </div>

    </div>
  `,

      showCancelButton: true,

      confirmButtonText: "Cadastrar",

      cancelButtonText: "Cancelar",

      confirmButtonColor: "#1686bd",

      cancelButtonColor: "#26394a",

      reverseButtons: true,

      focusConfirm: false,

      customClass: {

        popup:
          "swal-grupo-cadastro-popup",

        title:
          "swal-grupo-cadastro-title",

        htmlContainer:
          "swal-grupo-cadastro-html",

        confirmButton:
          "swal-grupo-cadastro-confirm",

        cancelButton:
          "swal-grupo-cadastro-cancel",

        actions:
          "swal-grupo-cadastro-actions",

      },

      buttonsStyling: false,

      scrollbarPadding: false,

      heightAuto: false,

    });


    if (!confirm.isConfirmed) {
      return;
    }


    /* -------------------------------------------------------
       TRY
       ------------------------------------------------------- */

    try {

      /* -----------------------------------------------------
         LOADING
         ----------------------------------------------------- */

      Swal.fire({

        title: "Cadastrando grupo...",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "390px",
        padding: "1.4rem",

        showConfirmButton: false,

        allowOutsideClick: false,
        allowEscapeKey: false,

        scrollbarPadding: false,

        heightAuto: false,

        html: `
    <div class="swal-grupo-cadastrando">

      <div class="swal-grupo-cadastrando-loader">

        <div class="swal-grupo-cadastrando-spinner"></div>

      </div>


      <div class="swal-grupo-cadastrando-text">
        Salvando informações
      </div>


      <div class="swal-grupo-cadastrando-subtext">
        Aguarde enquanto o grupo é cadastrado.
      </div>

    </div>
  `,

        customClass: {

          popup:
            "swal-grupo-cadastrando-popup",

          title:
            "swal-grupo-cadastrando-title",

          htmlContainer:
            "swal-grupo-cadastrando-html",

        },

        buttonsStyling: false,

      });

      /* -----------------------------------------------------
         DADOS
         ----------------------------------------------------- */

      const placa = notificacoesSelecionadas
        .map((p) => `'${p}'`)
        .join(",");

      const cliente = localStorage.getItem("id");
      const criado_por = localStorage.getItem("clientID");


      console.log("Dados enviados para API:", {
        ...values,
        placa,
        cliente,
        criado_por,
      });


      /* -----------------------------------------------------
         API + DELAY
         ----------------------------------------------------- */



      await Promise.all([
        api.post("/grupo", {
          ...values,
          placa,
          cliente,
          criado_por,
        }),
        new Promise((resolve) => setTimeout(resolve, 1800)),
      ]);

      // Avisa a lista para atualizar os grupos
      window.dispatchEvent(new Event("grupos-atualizados"));







      /* -----------------------------------------------------
         FECHAR LOADING
         ----------------------------------------------------- */

      Swal.close();


      /* -----------------------------------------------------
         SUCESSO
         ----------------------------------------------------- */

      await Swal.fire({

        title: "Grupo cadastrado",

        icon: "success",
        iconColor: "#22c55e",

        background: "#0b1722",
        color: "#e8f1f7",

        width: "390px",
        padding: "1.4rem",

        timer: 2200,

        showConfirmButton: false,

        timerProgressBar: true,

        scrollbarPadding: false,

        heightAuto: false,

        customClass: {

          popup:
            "swal-grupo-sucesso-popup",

          title:
            "swal-grupo-sucesso-title",

          htmlContainer:
            "swal-grupo-sucesso-html",

          timerProgressBar:
            "swal-grupo-sucesso-progress",

        },

        html: `
    <div class="swal-grupo-sucesso">

      <div class="swal-grupo-sucesso-message">
        O grupo foi cadastrado no sistema.
      </div>

    </div>
  `,
      });


      /* -----------------------------------------------------
         VOLTAR
         ----------------------------------------------------- */

      navigate(-1);

    } catch (error) {

      console.error(
        "Erro ao cadastrar grupo:",
        error
      );

      Swal.close();

      Swal.fire({
        icon: "error",

        title: "Erro",

        text: "Erro ao cadastrar grupo.",

        background: "#0f172a",
        color: "#ffffff",

        confirmButtonColor: "#0ea5e9",

        scrollbarPadding: false,
        heightAuto: false,
      });
    }
  };


  /* =========================================================
     JSX
     ========================================================= */

  return (
    <div className="grupo-cadastro-page">

      <div className="grupo-cadastro-container">

        <ToastContainer />

        {/* ===================================================
            CARD PRINCIPAL
            =================================================== */}

        <div className="grupo-cadastro-card">

          {/* =================================================
              HEADER
              ================================================= */}

          <div className="grupo-cadastro-header">

            <h5 className="grupo-cadastro-title">
              Cadastro de grupos
            </h5>

          </div>


          {/* =================================================
              FORMULÁRIO
              ================================================= */}

          <div className="grupo-cadastro-form">

            <form onSubmit={handleSubmit}>

              {/* =============================================
                  NOME
                  ============================================= */}

              <div className="grupo-field grupo-field-full">

                <label className="grupo-label">
                  Nome
                </label>

                <input
                  type="text"
                  placeholder="Nome do grupo"
                  name="nome"
                  className="grupo-input"
                  value={values.nome || ""}
                  maxLength={MAX_NOME}
                  required
                  onChange={handleChange}
                />

                <small
                  className="grupo-helper"
                  style={{
                    color:
                      MAX_NOME -
                        (values.nome?.length || 0) <= 10
                        ? "#f87171"
                        : "#94a3b8",
                  }}
                >
                  {MAX_NOME -
                    (values.nome?.length || 0)}{" "}
                  caracteres restantes
                </small>

              </div>


              {/* =============================================
                  BUSCA + TODOS
                  ============================================= */}

              <div className="grupo-top-row">

                {/* BUSCA Veículos DISPONIVEIS */}

                <div className="grupo-field">

                  <label className="grupo-label">
                    Veículos
                  </label>

                  <input
                    type="text"
                    className="grupo-input"
                    placeholder="Buscar por placa ou descrição"
                    value={searchVeiculos}
                    onChange={(e) =>
                      setSearchVeiculos(e.target.value)
                    }
                  />

                </div>

                <div className="grupo-field">

                  <label className="grupo-label">
                    Veículos selecionados
                  </label>

                  <input
                    type="text"
                    className="grupo-input"
                    placeholder="Buscar por placa ou descrição"
                    value={searchVeiculosSelecionados}
                    onChange={(e) =>
                      setSearchVeiculosSelecionados(e.target.value)
                    }
                  />

                </div>


                {/* ESCOLHER TODOS */}

                <div className="grupo-select-all">

                  <label className="grupo-checkbox-label">

                    <span>
                      Escolher todos os{" "}
                      <strong>
                        veículos
                      </strong>
                    </span>

                    <input
                      className="grupo-checkbox"
                      type="checkbox"
                      onChange={(e) =>
                        handleAll(e.target.checked)
                      }
                    />

                  </label>

                </div>

              </div>


              {/* =============================================
                  LISTAS DE VEÍCULOS
                  ============================================= */}

              <div className="grupo-listas">

                {/* =========================================
                    VEÍCULOS DISPONÍVEIS
                    ========================================= */}

                <div className="grupo-lista">

                  <div className="grupo-lista-header">
                    Placa - Descrição
                  </div>


                  {loadingVeiculos || mostrarLoading ? (

                    <div className="grupo-loading">

                      <div className="grupo-loading-spinner"></div>

                      <span>
                        Carregando veículos...
                      </span>

                    </div>

                  ) : (



                    <div className="grupo-veiculos-select">
                      {[...filterPlaca]
                        .sort((a, b) => {
                          const [placaA, ...descricaoA] = a.split(" | ");
                          const [placaB, ...descricaoB] = b.split(" | ");

                          const comparacaoPlaca = placaA.localeCompare(placaB, "pt-BR", {
                            sensitivity: "base",
                          });

                          if (comparacaoPlaca !== 0) {
                            return comparacaoPlaca;
                          }

                          return descricaoA
                            .join(" | ")
                            .localeCompare(descricaoB.join(" | "), "pt-BR", {
                              sensitivity: "base",
                            });
                        })
                        .map((notificacao, index) => {
                          const [placa, ...descricao] = notificacao.split(" | ");

                          return (
                            <div
                              key={`${placa}-${index}`}
                              className="grupo-veiculos-option"
                              onClick={() => handleSelecionadas(notificacao)}
                            >
                              <span className="veiculo-placa">{placa}</span>

                              <span className="veiculo-descricao">
                                {descricao.join(" | ")}
                              </span>
                            </div>
                          );
                        })}
                    </div>


                  )}

                </div>


                {/* =========================================
                    VEÍCULOS SELECIONADOS
                    ========================================= */}


                <div className="grupo-lista">
                  <div className="grupo-lista-header">
                    Selecionados
                  </div>

                  <div className="
        grupo-veiculos-select
        grupo-veiculos-select-selected
    ">
                    {[...filterVeiculosSelecionados]
                      .sort((a, b) => {
                        const [placaA, ...descricaoA] = a.split(" | ");
                        const [placaB, ...descricaoB] = b.split(" | ");

                        const comparacaoPlaca = placaA.localeCompare(placaB, "pt-BR", {
                          sensitivity: "base",
                        });

                        if (comparacaoPlaca !== 0) {
                          return comparacaoPlaca;
                        }

                        return descricaoA
                          .join(" | ")
                          .localeCompare(descricaoB.join(" | "), "pt-BR", {
                            sensitivity: "base",
                          });
                      })
                      .map((notificacao, index) => {
                        const [placa, ...descricao] = notificacao.split(" | ");

                        return (
                          <div
                            key={`${placa}-${index}`}
                            className="grupo-veiculos-option"
                            onClick={() => handlePredefinidas(notificacao)}
                          >
                            <span className="veiculo-placa">{placa}</span>

                            <span className="veiculo-descricao">
                              {descricao.join(" | ")}
                            </span>
                          </div>
                        );
                      })}
                  </div>
                </div>

              </div>


              {/* =============================================
                  BOTÕES
                  ============================================= */}

              <div className="grupo-cadastro-actions">

                <button
                  type="submit"
                  className="
                    grupo-btn
                    grupo-btn-primary
                  "
                  disabled={
                    notificacoesSelecionadas.length === 0
                  }
                >
                  Cadastrar
                </button>


                <button
                  type="button"
                  className="
                    grupo-btn
                    grupo-btn-danger
                  "
                  onClick={() => navigate(-1)}
                >
                  Cancelar
                </button>

              </div>

            </form>

          </div>

        </div>

      </div>

    </div>
  );
}